<template>
  <div class="w-100">
    <div class="accordion">
      <b-card no-body>
        <b-card-header @click="setIsOpen" header-tag="header" role="tab">
          <div class="row">
            <div class="col-6 accordion__title">
              <b-icon
                  icon="arrow-down-short"
                  variant="dark"
              >
              </b-icon>
              <strong>
                {{ $t('modal.segment.payment_balance_rule_title') }}
              </strong>
            </div>
            <div class="d-flex justify-content-end align-items-center col-6 text-right">
              <p v-if="isEdited" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_is_edited') }}</p>
              <p v-if="v.$invalid && v.$anyDirty" class="text-danger mr-5 mb-0">{{ $t('error.segment.segment_required') }}</p>
              <button @click="destroy" class="btn btn-xs btn-danger delete-translation-btn">{{ $t('btn.segment.delete_segment') }}</button>
            </div>
          </div>
        </b-card-header>

        <b-collapse :visible="isOpen" accordion="paymentBalance" role="tabpanel">
          <div style="height: 520px;">
            <div class="row p-4 pt-5 d-flex justify-content-center align-items-start">
              <div class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_amount')"
                    label-for="amount"
                >
                  <b-form-input v-model="amount" @input="emitSelectedValue('amount')" name="amount" id="amount"></b-form-input>
                  <div class="">
                    <p v-if="v.amount.$dirty && v.amount.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

              <div class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_currency')"
                    label-for="currency"
                >
                  <b-form-select v-model="currency" @input="emitSelectedValue('currency')" :options="options.currency"></b-form-select>
                  <div class="">
                    <p v-if="v.currency.$dirty && v.currency.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                  </div>
                </b-form-group>
              </div>

              <div class="col-4">
                <b-form-group
                    :label="$t('segment.label.set_segment_operation')"
                    label-for="operation">
                  <b-form-select v-model="operation" @input="emitSelectedValue('operation')" :options="options.operation"></b-form-select>
                <div class="">
                  <p v-if="v.operation.$dirty && v.operation.$invalid" class="text-danger">{{ $t('error.required') }}</p>
                </div>
                </b-form-group>
              </div>
              </div>
            </div>

            <div class="row pr-4 d-flex justify-content-center align-items-start">
              <div class="col-12">
                <button v-if="isEditType" :disabled="!isEdited" @click="saveEditedRule" class="float-right btn btn-xs btn-success">{{ $t('btn.segment.save_edited_rule') }}</button>
              </div>
            </div>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import {userSegment} from "../../../../common/constants/userSegment";

export default {
  props: {
    v: {
      type: Object,
      required: true
    },
    paymentBalanceForm: Object,
    isEditType: {
      type: Boolean,
      default: false
    },
    ruleId: {
      type: String,
      default: null,
      required: false
    },
    methodPost: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    isEdited: function () {
      return this.$store.getters[`userSegment/getEditedRule`](userSegment.paymentBalance);
    }
  },
  mounted() {
    this.$parent.$on('checkValidation', () => {
      this.v.$touch();
    });

    // POTRZEBNE PRZY EDYCJI
    // if(this.paymentBalanceForm.locales.length > 0) {
    //   this.locale = this.paymentBalanceForm.locales;
    //   this.timeOperation = this.paymentBalanceForm.timeOperation;
    //
    //   this.locale = this.options.localeRule.filter(rule => {
    //     if(this.paymentBalanceForm.locale.includes(rule.locale)) {
    //       return rule;
    //     }
    //   });
    // }
  },
  data() {
    return {
      isOpen: false,
      amount: '',
      operation: '',
      currency: '',
      options: {
        currency: [
          {value: 'FUN_COINS', text: this.$t('segment.option.fun_coins')},
          {value: 'QUIZ_COINS', text: this.$t('segment.option.quiz_coins')}
        ],
        operation: [
          {value: 'GT', text: this.$t('segment.option.greater_than')},
          {value: 'GTE', text: this.$t('segment.option.greater_than_or_equal')},
          {value: 'LT', text: this.$t('segment.option.less_than')},
          {value: 'LTE', text: this.$t('segment.option.less_than_or_equal')},
        ]
      }
    }
  },
  methods: {
    saveEditedRule() {
      this.$parent.$emit('editRule', {type: userSegment.paymentBalance, ruleId: this.ruleId, methodPost: this.methodPost});
    },
    deleteSegmentRule() {
      this.$parent.$emit('deleteSegmentRule', this.ruleId);
    },
    destroy() {
      const data = {
        component: this,
        rule: userSegment.paymentBalance,
        ruleId: this.ruleId
      }

      this.$parent.$emit('removePaymentBalanceRule', data);
    },
    setIsOpen() {
      if(this.isEditType && !this.isEdited) {
        this.isOpen = !this.isOpen;
        return;
      } else if(this.isEditType && this.isEdited) {
        return;
      }

      this.isOpen = !this.isOpen;
    },
    emitSelectedValue(type) {

      if(this.isEditType) {
        const data = {
          key: userSegment.paymentBalance,
          value: true
        }

        this.$store.commit('userSegment/setEditedRule', data);
      }

      this.$parent.$emit('selectedPaymentBalance', {
        type: type,
        amount: this.amount,
        currency: this.currency,
        operation: this.operation
      });
    }
  }
}
</script>